<script setup>
import {onMounted, ref} from "vue";

const form = ref(null);

onMounted(async () => {
  await new Promise((resolve,reject) => {
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://embed.typeform.com/next/embed.js';
    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.body.appendChild(scriptElement);
  });
  window.tf.createWidget('p3KzqUi9', { container: form.value })
});
</script>

<template>
  <div
    ref="form"
    data-tf-widget="p3KzqUi9"
    data-tf-opacity="100"
    data-tf-iframe-props="title=Get Matched"
    data-tf-transitive-search-params
    data-tf-medium="snippet"
    class="w-100 type-form-container"
  />
</template>

<style scoped>
.type-form-container {
    height: 700px;
    border-radius: 12px;
}
</style>
